export enum ApplicationStatus {
  STARTED = "STARTED",
  COMPLETED = "COMPLETED",
  SIGNED = "SIGNED",
}

export enum Gender {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

export const PREFERRED_COUNTRIES = [
  { code: "CH", telephoneCode: "+41" },
  { code: "DE", telephoneCode: "+49" },
  { code: "AT", telephoneCode: "+43" },
  { code: "FR", telephoneCode: "+33" },
  { code: "IT", telephoneCode: "+39" },
  { code: "LI", telephoneCode: "+423" },
];

export const DEFAULT_COUNTRY = PREFERRED_COUNTRIES[0].code;
export const DEFAULT_TELEPHONE_CODE = PREFERRED_COUNTRIES[0].telephoneCode;
